const getIdValue = (keys, item) => {
  let id = '';
  id += keys.map((key) => item[key]);
  return id;
};

const removeDuplicates = (arr, keys) => {
  const elements = new Set();
  return arr.filter((item) => (!elements.has(getIdValue(keys, item)) ? elements.add(getIdValue(keys, item)) : false));
};

export { removeDuplicates };
